import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backgroundImage", "form", "formField"]
  static values = {
    images: Array,
    currentId: Number,
    pageType: String,
  }

  declare readonly formTarget: HTMLFormElement
  declare readonly formFieldTarget: HTMLInputElement

  declare imagesValue: { id: number; image: string }[]
  declare currentIdValue: number
  declare pageTypeValue: string

  next() {
    const currentIndex = this.imagesValue.findIndex(({ id }) => id === this.currentIdValue)
    const nextIndex = (currentIndex + 1) % this.imagesValue.length
    this.setIndex(nextIndex)
  }

  previous() {
    const currentIndex = this.imagesValue.findIndex(({ id }) => id === this.currentIdValue)
    const previousIndex = (currentIndex - 1 + this.imagesValue.length) % this.imagesValue.length
    this.setIndex(previousIndex)
  }

  setIndex(index: number) {
    this.currentIdValue = this.imagesValue[index].id
    this.formFieldTarget.value = this.imagesValue[index].id.toString()
    this.formTarget.requestSubmit()
    this.element.dispatchEvent(
      new CustomEvent("layout-switcher:layout-changed", {
        bubbles: true,
        composed: true,
        detail: { pageType: this.pageTypeValue, image: this.imagesValue[index].image },
      }),
    )
  }
}
